// Asynchronous function that retrieves authentication configuration from Firestore.
export const getAuthConfig = async ($fire: any) => {
  return await $fire.firestore.collection('settings').doc('authConfig').get()
}
